// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialog-backdrop[data-v-e236865c] {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.2)
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/dialogs/DialogBackdrop.vue"],"names":[],"mappings":";AAUA;IAAA,eAAA;IAAA,MAAA;IAAA,SAAA;IAAA,OAAA;IAAA,QAAA;IAAA;AAAA","sourcesContent":["<template>\n  <Animation :duration=\"{ enter: 350, leave: 200 }\" enter=\"fadeIn\" leave=\"fadeOut\" appear>\n    <div class=\"dialog-backdrop\">\n      <slot />\n    </div>\n  </Animation>\n</template>\n\n<style lang=\"postcss\" scoped>\n.dialog-backdrop {\n  @apply fixed top-0 bottom-0 left-0 right-0 bg-[rgba(0,0,0,0.2)];\n}\n</style>\n\n<script>\nimport Animation from '@/lego/components/tools/Animation.vue';\n\nexport default {\n  name: 'DialogBackdropComponent',\n\n  components: { Animation },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
